import { Fragment, ReactNode, useEffect } from "react";
import { useRouter } from "next/router";

import { emit } from "@zapier/events-toolkit-browser";
import { useCurrentAccountId } from "@zapier/identity";
import { isDatadog } from "../../utils/isDatadog";

type Props = {
  children: ReactNode;
};

export function TrackRouting({ children }: Props) {
  const currentAccountId = useCurrentAccountId();
  const { asPath: path } = useRouter();

  useEffect(() => {
    if (
      // Only track on the client side
      typeof window !== "undefined" &&
      // and do not track the pre-hydrated path that doesn't include the
      // real params (i.e. [accountId])
      !(path.includes("[") && path.includes("]")) &&
      // Do not track DataDog monitors
      !isDatadog() &&
      // Do not track embeds as page views
      !path.includes("/embed/reporting")
    ) {
      // We only need to specify the system name that should be used for the PageViewEvent
      // The other PageViewEvent fields are set by automatically by events-toolkit-browser and the v4 Events API
      // https://engineering.zapier.com/guides/event-streaming/tracking-events/
      emit(
        {
          account_id: currentAccountId,
          system_name: "reporting",
        },
        "web_analytics.tracking.page_view.PageViewEvent"
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  return <Fragment>{children}</Fragment>;
}
